export const call = {
  state: {
    init: {
      description: `
      Playback is a circuit element that allows the client to play back an audio recording. You can listen and download audio recordings.`
    }
  },
  input: {
    timeout: {
      label: 'Response timeout'
    },

    contact: {
      label: 'Contact method'
    }
  }
};
